// extracted by mini-css-extract-plugin
export default {"socialLinks":"SocialLinks_socialLinks__TufF3","socialLink":"SocialLinks_socialLink__XSLVq"};